import styled from 'styled-components';

export const Wrapper = styled.section`
  font:
    10px 'Montserrat',
    sans-serif !important;
  padding-top: 20px;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  width: fit-content;
`;

export const Content = styled.section`
  line-height: 24px;
  margin-bottom: 15px;
  font-size: 16px;
  padding: 20px 20px;
  color: #666;
  box-sizing: border-box;
  word-wrap: break-word;
  text-align: center;
`;

export const SubTitle = styled.h4`
  padding-top: 35px;
  padding-bottom: 5px;
  font-size: 24px;
  line-height: 30px;
  color: #222;
  font-weight: 400;
  box-sizing: border-box;
  word-wrap: break-word;
`;

export const ExternalLink = styled.a`
  color: #00a2e8;
  transition: 0.5s all ease;
  text-decoration: none;
  box-sizing: border-box;
  word-wrap: break-word;
  margin: 0 5px;
`;
